module.exports = __webpack_public_path__ + "img/8.e2c7ce9.png";